import { Component, Input } from '@angular/core'
import { NgClass, NgIf } from '@angular/common'
import { Card } from 'game-services'

@Component({
  selector: 'sans-card',
  standalone: true,
  imports: [NgClass, NgIf],
  templateUrl: './card.component.html',
  styleUrl: './card.component.scss',
})
export class CardComponent {
  @Input() isVertical = false
  @Input() isFaceUp = false
  @Input() card: Card = new Card({ rank: 'Seven', suite: 'Spades' })
  @Input() isSelectable = false
  @Input() shouldHighlight = false
}
